import { useSelector } from 'react-redux';

import { DatosGenerales } from './components/DatosGenerales';
import { Contraseña } from './components/Contraseña';
import { Cedulas } from './components/Cedulas';
import { Error, Forbidden, Loader } from '../../components';

import { useDatosGenerales } from './hooks/useDatosGenerales';

import styles from './Perfil.module.css';
import { roles } from '../../types/types';

export const Perfil = () => {

  const { user } = useSelector(state => state.auth);

  const { datosGeneralesQuery: { isLoading, isError, data: usuario } } = useDatosGenerales();

  return (user.rol === roles.MEDICO) ? (
    <>
      <div className={styles.header}>Perfil</div>
      {(isLoading)
        ? <Loader />
        : <>
          {(isError)
            ? <Error />
            : <>
              <div className={styles.panel}>
                <div className='row'>
                  <div className="col">
                    <div className={styles.panelSection}>
                      <DatosGenerales usuario={usuario} />
                    </div>
                    <div className={styles.panelSection}>
                      <div className="row">
                        <div className={(usuario.img !== null) ? "offset-md-0 col-md-12 offset-lg-2 col-lg-10" : "col"}>
                          <Contraseña />
                        </div>
                      </div>
                    </div>
                    <div className={styles.panelSection}>
                      <div className="row">
                        <div className={(usuario.img !== null) ? "offset-md-0 col-md-12 offset-lg-2 col-lg-10" : "col"}>
                          <Cedulas usuario={usuario} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        </>
      }
    </>
  ) : <div className='mt-3'><Forbidden /></div>
}
